import {createAction} from 'redux-actions';
import {handleActions} from '../../Utility/HandleActions';

//
// actionTypes
//
const UPDATE_CURRENT_BREAKPOINT = 'DBM/UI/BREAKPOINT/UPDATE_CURRENT_BREAKPOINT';

//
// Create actions
//
const updateCurrentBreakpoint = createAction(UPDATE_CURRENT_BREAKPOINT);

export const actionTypes = {
    UPDATE_CURRENT_BREAKPOINT
};

export const actions = {
    updateCurrentBreakpoint
};

//
// Export reducer
//
export const reducer = handleActions({
    [UPDATE_CURRENT_BREAKPOINT]: (breakpoint) =>
        (state) => {
            return state.setIn(['ui', 'currentBreakpoint'], breakpoint);
        }
});

const currentBreakpoint = (state) => state.getIn(['ui', 'currentBreakpoint']);

export const selectors = {
    currentBreakpoint
};
